/* Yoni Yoni — product page behaviour: gallery, accordions, variants, qty, sticky ATC, Kaching sync */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.querySelector('[data-yy-pdp]');
    if (!root) return;

    /* ---------- Gallery ---------- */
    var slides = root.querySelectorAll('[data-yy-slide]');
    var thumbs = root.querySelectorAll('[data-yy-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-yy-thumb');
        slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-yy-slide') === i); });
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });

    /* ---------- Phone gallery dots (CSS turns the stage into a swipe row) ---------- */
    var stage = root.querySelector('[data-yy-stage]');
    if (stage && slides.length > 1) {
      var dots = document.createElement('div');
      dots.className = 'yy-pdp__dots';
      dots.setAttribute('aria-label', 'Product photos');
      slides.forEach(function (s, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.setAttribute('aria-label', 'Photo ' + (i + 1) + ' of ' + slides.length);
        if (i === 0) d.classList.add('is-active');
        d.addEventListener('click', function () {
          stage.scrollTo({ left: s.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(d);
      });
      stage.insertAdjacentElement('afterend', dots);
      var dotBtns = dots.querySelectorAll('button');
      var dt = null;
      stage.addEventListener('scroll', function () {
        clearTimeout(dt);
        dt = setTimeout(function () {
          var i = Math.round(stage.scrollLeft / (stage.clientWidth || 1));
          dotBtns.forEach(function (b, n) { b.classList.toggle('is-active', n === i); });
        }, 60);
      }, { passive: true });
    }

    /* ---------- Accordions ---------- */
    root.querySelectorAll('[data-yy-acc]').forEach(function (item) {
      var head = item.querySelector('.yy-acc__head');
      var panel = item.querySelector('.yy-acc__panel');
      if (!head || !panel) return;
      function setOpen(open) {
        item.classList.toggle('is-open', open);
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
      }
      setOpen(item.classList.contains('is-open'));
      head.addEventListener('click', function () { setOpen(!item.classList.contains('is-open')); });
      window.addEventListener('resize', function () {
        if (item.classList.contains('is-open')) panel.style.maxHeight = panel.scrollHeight + 'px';
      });
    });

    /* ---------- Variants ---------- */
    var form = root.querySelector('#yy-pdp-form');
    var idInput = root.querySelector('[data-yy-variant-id]');
    var priceEl = root.querySelector('[data-yy-price]');
    var atc = root.querySelector('[data-yy-atc]');
    var stickyPrice = document.querySelector('[data-yy-sticky-price]');
    var variants = null;

    var dataEl = document.getElementById('yy-variant-data');
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = null; } }

    function selectedOptions() {
      var out = [];
      root.querySelectorAll('[data-yy-option-index]').forEach(function (grp, i) {
        var checked = grp.querySelector('input:checked');
        if (checked) {
          out[i] = checked.value;
          var label = root.querySelector('[data-yy-optval="' + i + '"]');
          if (label) label.textContent = checked.value.toLowerCase();
        }
      });
      return out;
    }

    function money(cents) {
      try {
        return new Intl.NumberFormat('en-GB', { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'GBP' }).format(cents / 100);
      } catch (e) { return '£' + (cents / 100).toFixed(2); }
    }

    function updateVariant() {
      if (!variants) return;
      var opts = selectedOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = money(match.price) + (match.compare_at_price > match.price ? ' <s class="yy-pdp__was">' + money(match.compare_at_price) + '</s>' : '');
      if (stickyPrice) stickyPrice.textContent = money(match.price);
      if (atc) {
        atc.disabled = !match.available;
        atc.textContent = match.available ? atc.dataset.label || atc.textContent : 'sold out';
      }
      var url = new URL(window.location);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
      /* Kaching re-renders its prices after a size change; re-sync once it has */
      setTimeout(syncBundlePrice, 350);
    }

    root.querySelectorAll('[data-yy-option-index] input').forEach(function (i) {
      i.addEventListener('change', updateVariant);
    });

    /* ---------- Quantity ---------- */
    var qtyInput = root.querySelector('[data-yy-qtyinput]');
    root.querySelectorAll('[data-yy-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var v = parseInt(qtyInput.value, 10) || 1;
        v = b.getAttribute('data-yy-qty') === '+' ? v + 1 : Math.max(1, v - 1);
        qtyInput.value = v;
      });
    });

    var css = document.createElement('style');
    css.textContent =
      '.yy-has-kaching .yy-pdp__qty{display:none!important}' +
      '.yy-has-kaching kaching-bundle .yy-k-first .kaching-bundles__bar-variants{display:none!important}' +
      '.yy-kaching-multi .yy-pdp__opt{display:none!important}' +
      '.yy-pdp__desc.is-clamped{display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;margin-bottom:4px}' +
      '.yy-pdp__more{background:none;border:0;padding:0;margin:0 0 14px;font:inherit;font-size:14px;color:var(--accent,#D21B41);text-decoration:underline;text-underline-offset:3px;cursor:pointer}';
    document.head.appendChild(css);

    /* ---------- Short description: clamp on phones, "read more" ---------- */
    var desc = root.querySelector('.yy-pdp__desc');
    if (desc && window.matchMedia('(max-width: 899px)').matches) {
      desc.classList.add('is-clamped');
      if (desc.scrollHeight > desc.clientHeight + 4) {
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'yy-pdp__more';
        more.textContent = 'read more';
        more.addEventListener('click', function () {
          var open = desc.classList.toggle('is-clamped');
          more.textContent = open ? 'read more' : 'read less';
        });
        desc.insertAdjacentElement('afterend', more);
      } else {
        desc.classList.remove('is-clamped');
      }
    }

    /* ---------- Kaching Bundles sync ----------
       Kaching sits inside our form and owns the quantity. Here we hide our own
       qty stepper, hide Kaching's size dropdown on the single-item option (our
       size buttons drive it), and mirror the selected option's real total into
       our price + sticky bar.

       SPEED (Oct 2026): this used to force-click "Buy 1" on page load (twice),
       because Kaching was set to preselect "Buy 2". Every forced click made
       Kaching recalculate and redraw the whole widget, which on slow phones
       showed up as long freezes. "Buy 1" is now the default INSIDE the Kaching
       app (Deals > bar > Selected by default), so the theme no longer touches
       the selection. If Buy 2 ever shows preselected again, fix it in Kaching. */
    var kRoot = null;

    function selectedBar() { return kRoot && kRoot.querySelector('.kaching-bundles__bar--selected'); }
    function firstBar() { return kRoot && kRoot.querySelector('.kaching-bundles__bar'); }

    function syncBundlePrice() {
      var fb = firstBar();
      if (fb && !fb.classList.contains('yy-k-first')) fb.classList.add('yy-k-first');
      var bar = selectedBar();
      if (!bar) return;
      var isSingle = bar === fb;
      form && form.classList.toggle('yy-kaching-multi', !isSingle);
      var p = bar.querySelector('.kaching-bundles__bar-price');
      var full = bar.querySelector('.kaching-bundles__bar-full-price');
      if (!p) return;
      var priceTxt = p.textContent.trim();
      var fullTxt = full ? full.textContent.trim() : '';
      if (priceEl) priceEl.innerHTML = priceTxt + (fullTxt && fullTxt !== priceTxt ? ' <s class="yy-pdp__was">' + fullTxt + '</s>' : '');
      if (stickyPrice) stickyPrice.textContent = priceTxt;
    }

    function initKaching() {
      kRoot = root.querySelector('kaching-bundle');
      if (!kRoot || !kRoot.querySelector('.kaching-bundles__bar')) return false;
      form && form.classList.add('yy-has-kaching');

      var prevSingle = true;
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () {
          syncBundlePrice();
          var bar = selectedBar();
          var nowSingle = bar && bar === firstBar();
          /* Coming back to Buy 1: re-push our size choice into Kaching */
          if (nowSingle && !prevSingle) {
            var checked = root.querySelector('[data-yy-option-index] input:checked');
            if (checked) checked.dispatchEvent(new Event('change', { bubbles: true }));
          }
          prevSingle = !!nowSingle;
        }, 80);
      }).observe(kRoot, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'], characterData: true });

      syncBundlePrice();
      return true;
    }

    if (form) {
      var tries = 0;
      var poll = setInterval(function () {
        tries++;
        if (initKaching() || tries > 60) clearInterval(poll);
      }, 200);
    }


    /* ---------- Sticky ATC ---------- */
    var sticky = document.querySelector('[data-yy-sticky]');
    var buybox = root.querySelector('[data-yy-buybox]');
    if (sticky && buybox) {
      sticky.hidden = false;
      var onScroll = function () {
        var r = buybox.getBoundingClientRect();
        var on = r.bottom < 90;
        sticky.classList.toggle('is-on', on);
        /* yy-base.css lifts Chat / Rewards / currency above the sticky bar */
        document.body.classList.toggle('yy-sticky-on', on);
      };
      /* Once a shopper opens chat, stop shifting it so the open panel isn't cut off */
      var chat = document.querySelector('shopify-chat');
      if (chat) chat.addEventListener('click', function () { document.body.classList.add('yy-chat-used'); }, true);
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      var sBtn = sticky.querySelector('[data-yy-sticky-atc]');
      if (sBtn && form) sBtn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }
  });
})();
